import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryEntryVisibleParameter = 'visible' as const;
export const treasuryEntryOnboardingRequiredParameter =
  'onboarding-required' as const;

export const TreasuryEntryConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "TreasuryEntry" */
      '../../../components/MoneyManagement/TreasuryEntry/TreasuryEntry'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryEntryVisibleParameter]: {
      isInternal: true,
    },
    [treasuryEntryOnboardingRequiredParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close', 'treasuryentryctaclick'],
  customHtmlElementMethods: {
    setVisible: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryVisibleParameter,
      isInternal: true,
      description: 'Sets whether the Treasury entry modal is visible.',
    },
    setOnboardingRequired: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryOnboardingRequiredParameter,
      isInternal: true,
      description:
        'Sets whether the welcome CTA continues into financial account onboarding.',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description:
        'Sets the event listener called when the Treasury entry modal is dismissed.',
    },
    setOnCtaClick: {
      type: 'EventListenerMethod',
      event: 'treasuryentryctaclick',
      isInternal: true,
      description:
        'Sets the event listener called when the Treasury entry call to action is selected.',
    },
  },
  optionalInlineOverlay: true,
  description: 'Modal to onboard users to new Treasury and Issuing features.',
  friendlyName: 'Treasury Entry',
};
